module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/47144cdb9c8e168e8013458020a28448.png";